// extracted by mini-css-extract-plugin
export default {"ecospendModal":"zPbS_9WdiwCaq0bIUWlw","ecospendModalHeader":"LOJkkK1Of_cOVTi_ri2I","ecospendModalContent":"U3jTi4kCOplnggNFc0Sw"};